import spacing from 'theme/config/spacing'

export default {
  paper: {
    borderRadius: '1.6rem',
    padding: spacing(1),
    boxShadow: '0 5px 12px 0 rgba(0,0,0,0.12)'
  }
};
